// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f868b6bd","239":"3f514825","453":"908ec7a6","455":"95c99f91"}[chunkId] + ".chunk.js";
};